import { createStore } from 'vuex';
import AuthService from '@/services/AuthService'
export default createStore({
    strict: true,
    state: {
        token: null,
        user: null,
        isUserLoggedIn: false
    },
    mutations: {
        setUser(state, user) {
            if (user) {
                state.user = user
                state.isUserLoggedIn = true
            }
           else  state.isUserLoggedIn = false
        },
    },
    actions: {
        setUser({ commit }, user) {
            commit('setUser', user)
        },
        async getUser( {commit}) {
            console.log('getting user')
            try{
                const response = await AuthService.fetchUser()
                commit('setUser', response.data)
            }catch(ex){
                //clear user data
                console.log("User session doesnt exist", ex)
            }
        }
    },
    getters: {
      isImpersonated: state => state.user?.isImpersonated || false,
      isAuthenticated: state => state.isUserLoggedIn,
      isApproved: state => (state.user && state.user.status === 'approved') ?? false,
      isAdmin: state => (state.user && state.user.roles?.includes('admin')) ?? false,
      isSuperAdmin: state => (state.user && state.user.roles?.includes('superadmin')) ?? false,
      isSubAffiliate: state => (state.user && state.user.roles?.includes('subaffiliate')) ?? false,
      isFinance: state => (state.user && state.user.roles?.includes('finance')) ?? false,
      name: state => state.user ? state.user.type === 'Company' ? state.user.companyName : state.user.name : null,
      isSeo: state => (state.user && state.user.userType === 'seo') ?? false,
      userId: state => state.user?.id ?? null,
      isCompany: state => (state.user && state.user.type === 'Company') ?? false
    }
})